import { HttpResponse } from '@angular/common/http';
import { UntypedFormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as CryptoJS from 'crypto-js/crypto-js';
import { environment } from 'environments/environment';
import * as fileSaver from 'file-saver';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { combineLatest, concat, Observable, Subject } from 'rxjs';
import { finalize, map, takeUntil } from 'rxjs/operators';
import { v1 as uuid } from 'uuid';
import { Costanti, CostantiStorage } from './costanti';
import { DialogStampaContent } from './dialog/dialog-stampa/dialog-stampa.component';

export type TipoCorso = 'fad' | 'res' | 'blended' | '8108' | 'gdpr' | 'gdpr dipendenti' | 'aso';

export class Utils {
  public static MimeTypes = {
    PDF: 'application/pdf',
    TEXT: 'text/plain',
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ZIP: 'application/zip',
    XML: 'application/xml'
  };
  public static openBlob(response: HttpResponse<Blob>, mimeType = Utils.MimeTypes.PDF) {
    const cdHeader = response.headers.get('Content-Disposition');
    if (cdHeader) {
      const blob = new Blob([response.body], { type: mimeType });
      if (mimeType == Utils.MimeTypes.PDF) {
        const url = URL.createObjectURL(blob);
        window.open(url);
      } else {
        const [, filename] = cdHeader.match(/filename="(.+)"/);
        fileSaver.saveAs(blob, filename);
      }
    }
  }
  public static checkErrorDownloadFile(thiss, data) {
    if (!data) {
      Utils.showMessage(thiss.toastrService, 0);
      return;
    }
    const self = thiss;
    const fr = new FileReader();
    fr.onload = function (evt) {
      // console.log('onload', JSON.parse(evt.target['result']));
      try {
        const jsonParse = JSON.parse(evt.target['result'].toString());
        // console.log(jsonParse);
        if (jsonParse) {
          if (jsonParse.data && jsonParse.data.error_desc) {
            Utils.showMessageGenerico(self.toastrService, 0, jsonParse.data.error_desc, '', 6);
          } else {
            Utils.showMessage(self.toastrService, 0);
          }
        }
      } catch (error) {
        // console.error(error);
      }
      // dialogStampa.close();
    };
    fr.readAsText(data.body);
  }
  public static getAnniDa(currentYear: number, fromYear: number = Costanti.FILTER_FROM_YEAR): number[] {
    const anni = Array(currentYear - fromYear + 1)
      .fill(0)
      .map((_, i) => fromYear + i)
      .reverse();
    return anni;
  }

  public static checkCF(cfins) {
    if (!cfins) {
      return false;
    }
    if (cfins.length < 16) {
      return false;
    }
    // const pattern = /^([A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1})$|([0-9]{11})$/;
    const pattern =
      /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;

    return cfins.search(pattern) !== -1;
    // if (!cfins) {
    //   return false;
    // }
    // if (cfins.length < 16) {
    //   return false;
    // }
    // let cf = cfins.toUpperCase();
    // let cfReg = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;
    // if (!cfReg.test(cf)) return false;
    // let set1 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    // let set2 = 'ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ';
    // let setpari = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    // let setdisp = 'BAKPLCQDREVOSFTGUHMINJWZYX';
    // let s = 0;
    // let i = 0;
    // for (i = 1; i <= 13; i += 2) s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    // for (i = 0; i <= 14; i += 2) s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    // if (s % 26 != cf.charCodeAt(15) - 'A'.charCodeAt(0)) return false;
    // return true;
  }
  public static checkCFOmocodia(cfins) {
    if (!cfins) {
      return false;
    }
    if (cfins.length < 16) {
      return false;
    }
    // const pattern = /^([A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1})$|([0-9]{11})$/;
    const pattern =
      /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;

    return cfins.search(pattern) !== -1;
    // if (!cfins) {
    //   return false;
    // }
    // let cf = cfins.toUpperCase();
    // let cfReg = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;
    // if (!cfReg.test(cf)) return false;
    // let set1 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    // let set2 = 'ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ';
    // let setpari = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    // let setdisp = 'BAKPLCQDREVOSFTGUHMINJWZYX';
    // let s = 0;
    // let i = 0;
    // for (i = 1; i <= 13; i += 2) s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    // for (i = 0; i <= 14; i += 2) s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    // if (s % 26 != cf.charCodeAt(15) - 'A'.charCodeAt(0)) return false;
    // return true;
  }
  public static ClearStorageKey(all?) {
    if (all) {
      for (const tmp of Object.keys(CostantiStorage).map(key => CostantiStorage[key])) {
        localStorage.removeItem(tmp);
      }
    } else {
      for (const tmp of Object.keys(CostantiStorage).map(key => CostantiStorage[key])) {
        if (
          tmp !== CostantiStorage.TOKEN &&
          tmp !== CostantiStorage.TOKENPASS &&
          tmp !== CostantiStorage.STATE &&
          tmp !== CostantiStorage.IDSTUDIOATTIVO &&
          tmp !== CostantiStorage.NOMESTUDIOATTIVO &&
          tmp !== CostantiStorage.VERSION
        ) {
          localStorage.removeItem(tmp);
        }
      }
    }
  }
  public static SHA256(text) {
    if (!text || text.length === 0) {
      return '';
    }
    return CryptoJS.SHA256(text).toString();
  }
  public static ReplaceAll(str, find, replace) {
    if (!str) {
      return '';
    }
    return str.toString().replace(new RegExp(find, 'g'), replace);
  }
  public static getDataFormatted(dataString, formato?, inputFormat?) {
    moment.locale('it');
    if (!dataString || dataString === 'null' || dataString === 'Invalid date') {
      return '';
    }
    if (!moment(dataString).isValid()) return '';
    return moment(dataString, inputFormat).format(formato || 'DD/MM/YYYY');
  }
  public static disableUnsubscribe(unsub: Subject<any>) {
    unsub.next(undefined);
    unsub.next(true);
    unsub.complete();
    unsub.unsubscribe();
  }
  public static FormatTwoDigit(str) {
    if (!str) {
      return '';
    }
    return ('0' + str).slice(-2);
  }
  public static RoundFloat(num) {
    return +(Math.round(num * 100) / 100).toFixed(2);
  }
  public static StringIsNullOrEmpty(stringa) {
    return !stringa || 0 === stringa.length || !stringa.trim();
  }
  public static openStampaDialog(dialog) {
    return dialog.open(DialogStampaContent, {
      disableClose: false,
      maxWidth: '100vw'
      // width: '300px',
      // height: '300px'
    });
  }
  public static ConvertDateNoTimezone(date: Date) {
    return moment.utc(date).add(-1 * (moment.utc(date).utcOffset() - moment(date).utcOffset()), 'minutes');
  }
  public static showMessage(toastrService, tipologia?) {
    if (tipologia === 1) {
      toastrService.success(Costanti.TRADUZIONI['SUCCESS'], Costanti.TRADUZIONI['TITOLO']);
    } else {
      toastrService.error(Costanti.TRADUZIONI['ERROR'], Costanti.TRADUZIONI['TITOLO']);
    }
  }
  public static showMessageWithTime(toastrService, tipologia?, tempo?) {
    if (tipologia === 1) {
      toastrService.success(Costanti.TRADUZIONI['SUCCESS'], Costanti.TRADUZIONI['TITOLO'], {
        timeOut: tempo ? tempo * 1000 : 5000
      });
    } else {
      toastrService.error(Costanti.TRADUZIONI['ERROR'], Costanti.TRADUZIONI['TITOLO'], {
        timeOut: tempo ? tempo * 1000 : 5000
      });
    }
  }
  public static showMessageResponse(toastrService, data) {
    if (data['response'] === 1) {
      toastrService.success(Costanti.TRADUZIONI['SUCCESS'], Costanti.TRADUZIONI['TITOLO']);
    } else {
      toastrService.error(Costanti.TRADUZIONI['ERROR'], Costanti.TRADUZIONI['TITOLO']);
    }
  }
  public static showMessageGenerico(toastrService: ToastrService, tipologia?, msg?, titolo?, tempo?) {
    if (tipologia === 1) {
      if (msg) {
        toastrService.success(msg, titolo, {
          timeOut: tempo ? tempo * 1000 : 3000
        });
      } else {
        toastrService.success(Costanti.TRADUZIONI['SUCCESS'], Costanti.TRADUZIONI['TITOLO'], {
          timeOut: tempo ? tempo * 1000 : 3000
        });
      }
    } else {
      if (msg) {
        toastrService.error(msg, titolo, {
          timeOut: tempo ? tempo * 1000 : 3000
        });
      } else {
        toastrService.error(Costanti.TRADUZIONI['ERROR'], Costanti.TRADUZIONI['TITOLO'], {
          timeOut: tempo ? tempo * 1000 : 3000
        });
      }
    }
  }
  public static showMessageSnackGenerico(snackBar: MatSnackBar, tipologia?, msg?, tempo?) {
    if (tipologia === 1) {
      snackBar.open(msg ? msg : Costanti.TRADUZIONI['SUCCESS'], null, {
        duration: tempo ? tempo * 1000 : 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: 'snack-success'
      });
    } else {
      snackBar.open(msg ? msg : Costanti.TRADUZIONI['ERROR'], null, {
        duration: tempo ? tempo * 1000 : 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: 'snack-error'
      });
    }
  }
  public static getTipoCorso(value: TipoCorso) {
    if (typeof value === 'number') return value;

    const tipoMap = {
      fad: 1,
      res: 2,
      blended: 3
    };
    return tipoMap[value];
  }

  // Sottoscrive multipli Observable in serie (A start > A end > B start > B end > ...)
  public static rxSeries(observables: Array<Observable<any>>, unsub: Subject<any>, callback: Function) {
    const values = {};
    concat(...observables)
      .pipe(
        takeUntil(unsub),
        finalize(() => {
          callback(values);
        })
      )
      .subscribe(
        data => {
          // console.log(data, values);
          Object.assign(values, data);
        },
        err => {
          console.error({ err });
        }
      );
  }

  public static handlePdf(base64encodedPdfString: string): Promise<Blob> {
    return new Promise((resolve, reject) => {
      try {
        const binstr = atob(base64encodedPdfString);
        const len = binstr.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binstr.charCodeAt(i);
        }
        resolve(new Blob([bytes], { type: 'application/pdf' }));
      } catch (e) {
        reject(e);
      }
    });
  }

  public static getCsvFromJson(array: Object[], toUpper = false) {
    return new Promise(resolve => {
      let str = '';
      let header = '';
      for (const k of Object.keys(array[0])) {
        header += k + ';';
      }
      str += header + '\r\n';
      for (let i = 0; i < array.length; i++) {
        let line = '';
        // tslint:disable-next-line:forin
        for (const index in array[i]) {
          if (line != '') {
            line += ';';
          }
          const elt = array[i][index];
          if (elt === null) {
            line += ' ';
          } else {
            if (isNaN(elt)) {
              line += (toUpper ? elt.toString().toUpperCase() : elt) || '';
            } else {
              line += (elt === '' ? '' : toUpper ? elt.toString().toUpperCase() : elt) || '0';
            }
          }
        }
        str += line + '\r\n';
      }
      const blob = new Blob([str], { type: 'text/plain;charset=utf-8' });
      fileSaver.saveAs(blob, `export_${moment().format('YMMDD')}.csv`);
      resolve(1);
    });
  }

  public static openWindowForPrint(dataUrl?: string): Window {
    return window.open(dataUrl || '', '', 'left=0,top=0,width=750,height=900,toolbar=0,scrollbars=0,status=0');
  }

  public static openNewTabForPrint(dataUrl?: string): Window {
    console.log(dataUrl);
    return window.open(dataUrl || '', '_blank');
  }

  /**
   * Compara due array, restituendo due array:
   * il primo contiene gli elementi di `arr1` che non compaiono in `arr2`,
   * il secondo contiene gli elementi di `arr2` che non compaiono in `arr1`.
   * La ricerca in un `Set` ha una time-complexity pari a `O(1)`, pertanto è molto efficiente.
   * `Array.filter()` ha time-complexity `O(n)`, pertanto tutta la funzione risulta `O(n)`.
   * Utilizzando due `for...of` avremmo avuto una complexity di `O(n^2)`.
   * @param {Array<*>} arr1
   * @param {Array<*>} arr2
   * @return {Array<Array<*>>}
   * @see https://jsperf.com/array-partition-test123/1
   */
  public static compareUniques<T>(arr1: T[], arr2: T[]): T[][] {
    const s1 = new Set(arr1);
    const s2 = new Set(arr2);
    const r1 = arr1.filter(item => !s2.has(item));
    const r2 = arr2.filter(item => !s1.has(item));
    return [r1, r2];
  }

  public static safe<T>(o: T): T {
    return o || <T>{};
  }
  public static safeString(o: string): string {
    return o || '';
  }
  /**
   * Dati molteplici `Observable<boolean>`, restituisce un `Observable<boolean>` che è `true` se almeno uno degli input è `true`
   * @param {varargs Observable<boolean>} inputs Numero variabile di `Observable<boolean>`
   * @returns {Observable<boolean>}
   */
  public static combineLoaders(...inputs: Array<Observable<boolean>>): Observable<boolean> {
    return combineLatest(...inputs).pipe(map(e => e.some(Boolean)));
  }

  /**
   * Dati in input un array ed una callback, restituisce un array contenente gli elementi per cui la callback risulta truthy ed uno per cui risulta falsy
   * @param arr Array da partizionare
   * @param isValid Funzione da applicare ai singoli elementi
   * @param mergeResults Se `true` i due array interni vengono concatenati
   */
  public static partition<T>(arr: T[], isValid: (arg: T) => boolean): [T[], T[]];
  public static partition<T>(arr: T[], isValid: (arg: T) => boolean, mergeResults: true): T[];
  public static partition<T>(arr: T[], isValid: (arg: T) => boolean, mergeResults?: true): T[] | [T[], T[]] {
    const results = arr.reduce<[T[], T[]]>(
      ([pass, fail], elem) => (isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]]),
      [[], []] as [T[], T[]]
    );
    return mergeResults ? [...results[0], ...results[1]] : results;
  }

  public static moveSingleToFront<T>(source: T[], predicate: (elt: T) => boolean): T[] {
    const arr = source.slice();
    const eltIndex = arr.findIndex(predicate);
    if (eltIndex > -1) {
      const elt = arr.splice(eltIndex, 1);
      arr.unshift(...elt);
    }
    return arr;
  }

  public static formOnValueChanged(formCheck?: UntypedFormGroup, formErrors?, validationMessages?) {
    if (!formCheck) {
      return;
    }
    const form = formCheck;

    for (const field in formErrors) {
      formErrors[field] = '';
      const control = form.get(field);
      if (control && control.dirty && !control.valid) {
        const messages = validationMessages[field];

        // tslint:disable-next-line:forin
        for (const key in control.errors) {
          if (messages) {
            formErrors[field] += messages[key] + ' ';
          }
        }
      }
    }
  }

  public static markFormControlDirty(form: UntypedFormGroup) {
    for (const key in form.controls) {
      const control = form.controls[key];

      // console.log(key, control !== undefined, !control.value || control.value === '');
      if (control) {
        // if (!control.value || control.value === '') {
        control.markAsTouched();
        control.markAsDirty();
        // }
        control.updateValueAndValidity();
      }
    }
  }

  public static markFormControlClean(form: UntypedFormGroup) {
    for (const key in form.controls) {
      const control = form.controls[key];
      // console.log(key, control !== undefined, !control.value || control.value === '');
      if (control) {
        // if (!control.value || control.value === '') {
        control.markAsUntouched();
        control.markAsPristine();
        // }
        control.updateValueAndValidity();
      }
    }
  }

  public static today() {
    // Sì, so che esiste Moment...
    const today = new Date();
    const dd = ('00' + today.getDate()).slice(-2);
    const mm = ('00' + (today.getMonth() + 1)).slice(-2);
    const yyyy = today.getFullYear();
    return new Date(`${yyyy}/${mm}/${dd}`);
  }

  public static capitalizeFirst(str) {
    if (!str) {
      return str;
    }
    str = str.toString();
    const head = str.slice(0, 1).toUpperCase();
    const tail = str.slice(1).toLowerCase();
    return head + tail;
  }
  public static capitalizeOnlyFirst(str) {
    str = str.toString();
    const head = str.slice(0, 1).toUpperCase();
    const tail = str.slice(1);
    return head + tail;
  }
  public static capitalizeAll(str) {
    return str.toString().toUpperCase();
  }
  public static capitalizeFirstWords(str) {
    str = str.toString();
    const strings = str.split(' ');
    strings.forEach((string, index, arr) => {
      arr[index] = Utils.capitalizeFirst(string);
    });
    return strings.join(' ');
  }

  public static shuffleArray<T>(input: Array<T>): Array<T> {
    const copy = [...input];

    for (let i = copy.length; i; --i) {
      const j = Math.floor(Math.random() * i);
      const x = copy[i - 1];
      copy[i - 1] = copy[j];
      copy[j] = x;
    }

    return copy;
  }

  // #################################################################
  // FUNZIONI PER GENERAZIONE DI DATI RANDOM
  // NON NECESSARIE DOPO LA PRESENTAZIONE

  public static rndMinMax(min, max) {
    return Math.floor(Math.random() * (max + 1 - min) + min);
  }

  public static getRandomDate(options?) {
    /**
     * OPTIONS:
     *
     * d    => Fixed day
     * dMin => Minimum day (default 1)
     * dMax => Maximum day (default 31)
     *
     * m    => Fixed month
     * mMin => Minimum month (default 1)
     * mMax => Maximum month (default 12)
     *
     * y    => Fixed year
     * yMin => Minimum year (default 2000)
     * yMax => Maximum year (default current year)
     */

    options = options || {};

    const minDay = options.dMin || 1;
    const maxDay = options.dMax || 31;
    const minMonth = options.mMin || 1;
    const maxMonth = options.mMax || 12;
    const minYear = options.yMin || 2000;
    const maxYear = options.yMax || new Date().getFullYear();

    const getDay = () => ('00' + Utils.rndMinMax(minDay, maxDay)).slice(-2);
    const getMonth = () => ('00' + Utils.rndMinMax(minMonth, maxMonth)).slice(-2);
    const getYear = () => Utils.rndMinMax(minYear, maxYear);

    let d = options.d || getDay();
    let m = options.m || getMonth();
    let y = options.y || getYear();

    return `${d}/${m}/${y}`;
  }

  public static getRandomCarica(livello) {
    const cariche = [
      'Presidente %%s',
      'Vicepresidente Vicario %%s',
      'Vicepresidente %%s',
      'Segretario %%s',
      'Tesoriere %%s',
      'Segretario Sindacale %%s',
      'Segretario Culturale %%s',
      'Presidente del Collegio %%s dei Revisori dei Conti',
      'Effettivo del Collegio %%s dei Revisori dei Conti',
      'Presidente del Collegio %%s dei Probiviri di Primo Grado',
      'Vicepresidente del Collegio %%s dei Probiviri di Primo Grado'
    ];

    if (livello === 'ALL') {
      const allCariche = cariche.slice();
      allCariche.forEach((_, index, arr) => {
        arr[index] = arr[index].replace(/%%s/, 'Nazionale');
      });
      return allCariche;
    }

    return cariche[Math.floor(Math.random() * cariche.length)].replace(/%%s/, livello);
  }

  public static generateDatasetVersamenti(size) {
    const arr = [];

    for (let i = 0; i < size; i++) {
      arr.push({
        data: Utils.getRandomDate(),
        sezione: 'Rovigo',
        dipartimento: Math.random() < 0.5 ? 'Veneto' : '',
        quota: Number(`${Utils.rndMinMax(0, 14000)}.${Utils.rndMinMax(0, 99)}`)
      });
    }

    arr.sort((a, b) =>
      moment(a.data, 'DD-MM-YYYY').isAfter(moment(b.data, 'DD-MM-YYYY'))
        ? -1
        : moment(a.data, 'DD-MM-YYYY').isBefore(moment(b.data, 'DD-MM-YYYY'))
          ? 1
          : 0
    );

    return arr;
  }

  public static generateDatasetDettaglioVersamento(ds) {
    const size = Utils.rndMinMax(4, 8);
    const soci = _.sampleSize(ds, size);
    const arr = [];

    let numRicevuta = Utils.rndMinMax(10700, 10800);

    for (let i = 0; i < size; i++) {
      arr.push({
        socio: `${soci[i].titolo} ${soci[i].nome}`,
        ricevuta: numRicevuta++,
        data: Utils.getRandomDate({ y: '2018', m: '04' }),
        quota: 330,
        tipo: 'Intera',
        sconto: false, // Math.random() < 0.5,
        qualifica: 'Ordinario A',
        anno: 2018
      });
    }

    return arr;
  }
  public static validaData(e) {
    // Previene l'immissione di caratteri che non siano i seguenti:
    if (!(
      (e.keyCode >= 96 && e.keyCode <= 105) || // Numpad 0-9
      (e.keyCode >= 48 && e.keyCode <= 57) || //Numrow 0-9
      e.keyCode == 8 || // Backspace
      e.keyCode == 46 || // Delete
      e.keyCode == 197 || // Slash
      e.keyCode == 47 || // barra /
      (e.keyCode >= 37 && e.keyCode <= 40)
    )) {
      // Arrow keys
      return false;
    }
    return true;
  }
  public static noNegatives(e) {
    // Previene l'immissione di caratteri che non siano i seguenti:
    if (
      !(
        (e.keyCode >= 96 && e.keyCode <= 105) || // Numpad 0-9
        (e.keyCode >= 48 && e.keyCode <= 57) || // Numrow 0-9
        e.keyCode == 8 || // Backspace
        e.keyCode == 46 || // Delete
        e.keyCode == 188 || // Comma
        e.keyCode == 190 || // Dot
        e.keyCode == 110 || // Decimal point
        e.keyCode == 9 || // Tab
        (e.keyCode >= 37 && e.keyCode <= 40) ||
        (e.keyCode === 65 && e.ctrlKey === true) || // Allow: Ctrl+A
        (e.keyCode === 67 && e.ctrlKey === true) || // Allow: Ctrl+C
        (e.keyCode === 86 && e.ctrlKey === true) || // Allow: Ctrl+V
        (e.keyCode === 88 && e.ctrlKey === true) || // Allow: Ctrl+X
        (e.keyCode === 65 && e.metaKey === true) || // Allow: Cmd+A (Mac)
        (e.keyCode === 67 && e.metaKey === true) || // Allow: Cmd+C (Mac)
        (e.keyCode === 86 && e.metaKey === true) || // Allow: Cmd+V (Mac)
        (e.keyCode === 88 && e.metaKey === true)
      ) // Allow: Cmd+X (Mac)
    ) {
      // Arrow keys
      return false;
    }
    return true;
  }
  public static checkNumberNegDec(e) {
    // Previene l'immissione di caratteri che non siano i seguenti:
    if (
      !(
        (e.keyCode >= 96 && e.keyCode <= 105) || // Numpad 0-9
        (e.keyCode >= 48 && e.keyCode <= 57) || // Numrow 0-9
        e.keyCode == 8 || // Backspace
        e.keyCode == 46 || // Delete
        e.keyCode == 109 || // Numpad -
        e.keyCode == 188 || // Comma
        e.keyCode == 189 || // -
        e.keyCode == 110 || // Numpad .
        e.keyCode == 190 || // .
        e.keyCode == 9 || // Tab
        (e.keyCode >= 37 && e.keyCode <= 40) ||
        (e.keyCode === 65 && e.ctrlKey === true) || // Allow: Ctrl+A
        (e.keyCode === 67 && e.ctrlKey === true) || // Allow: Ctrl+C
        (e.keyCode === 86 && e.ctrlKey === true) || // Allow: Ctrl+V
        (e.keyCode === 88 && e.ctrlKey === true) || // Allow: Ctrl+X
        (e.keyCode === 65 && e.metaKey === true) || // Allow: Cmd+A (Mac)
        (e.keyCode === 67 && e.metaKey === true) || // Allow: Cmd+C (Mac)
        (e.keyCode === 86 && e.metaKey === true) || // Allow: Cmd+V (Mac)
        (e.keyCode === 88 && e.metaKey === true)
      ) // Allow: Cmd+X (Mac) // Arrow keys
    ) {
      return false;
    }
    return true;
  }
  public static checkNumberDigit(e) {
    // Previene l'immissione di caratteri che non siano i seguenti:
    if (e.shiftKey || e.altKey) {
      return false;
    }
    if (
      !(
        (e.keyCode >= 96 && e.keyCode <= 105) || // Numpad 0-9
        (e.keyCode >= 48 && e.keyCode <= 57) || // Numrow 0-9
        e.keyCode == 8 || // Backspace
        e.keyCode == 46 || // Delete
        e.keyCode == 9 || // Tab
        (e.keyCode >= 37 && e.keyCode <= 40) || // Arrow keys
        (e.keyCode === 65 && e.ctrlKey === true) || // Allow: Ctrl+A
        (e.keyCode === 67 && e.ctrlKey === true) || // Allow: Ctrl+C
        (e.keyCode === 86 && e.ctrlKey === true) || // Allow: Ctrl+V
        (e.keyCode === 88 && e.ctrlKey === true) || // Allow: Ctrl+X
        (e.keyCode === 65 && e.metaKey === true) || // Allow: Cmd+A (Mac)
        (e.keyCode === 67 && e.metaKey === true) || // Allow: Cmd+C (Mac)
        (e.keyCode === 86 && e.metaKey === true) || // Allow: Cmd+V (Mac)
        (e.keyCode === 88 && e.metaKey === true)
      ) // Allow: Cmd+X (Mac)
    ) {
      return false;
    }
    return true;
  }
  public static checkNumber(e) {
    // Previene l'immissione di caratteri che non siano i seguenti:
    if (
      !(
        (e.keyCode >= 96 && e.keyCode <= 105) || // Numpad 0-9
        (e.keyCode >= 48 && e.keyCode <= 57) || // Numrow 0-9
        e.keyCode == 8 || // Backspace
        e.keyCode == 46 || // Delete
        e.keyCode == 9 || // Tab
        (e.keyCode >= 37 && e.keyCode <= 40)
      ) // Arrow keys
    ) {
      return false;
    }
    return true;
  }
  public static checkData(e) {
    // Previene l'immissione di caratteri che non siano i seguenti:
    if (
      !(
        (e.keyCode >= 96 && e.keyCode <= 105) || // Numpad 0-9
        (e.keyCode >= 48 && e.keyCode <= 57) || // Numrow 0-9
        e.keyCode == 8 || // Backspace
        e.keyCode == 46 || // Delete
        e.keyCode == 111 || // Barra / (numpad)
        e.keyCode == 191 || // Barra / (- ENG layout)
        (e.keyCode >= 37 && e.keyCode <= 40)
      ) // Arrow keys
    ) {
      return false;
    }
    return true;
  }

  public static isApp(): boolean {
    // return true;
    return navigator.userAgent.includes(environment.appUserAgent);
  }

  public static fetchWithProgress(
    url: RequestInfo,
    fetchOptions: RequestInit = {}
  ): Observable<{ contentLength: number; receivedLength: number; done: boolean; content: Blob; percentage: number }> {
    const calculatePercentage = (partial: number, total: number): number => ((partial / total) * 100) | 0;

    const returnSubject = new Subject<{
      contentLength: number;
      receivedLength: number;
      percentage: number;
      done: boolean;
      content: Blob;
    }>();

    fetch(url, fetchOptions).then(async res => {
      const reader = res.body.getReader();
      const contentLength = +res.headers.get('Content-Length');
      let receivedLength = 0;
      let percentage = 0;
      const chunks = [];
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
        receivedLength += value.length;
        percentage = calculatePercentage(receivedLength, contentLength);
        returnSubject.next({
          contentLength,
          receivedLength,
          percentage,
          content: null,
          done: false
        });
      }
      const allChunks = new Uint8Array(receivedLength);
      let position = 0;
      for (const chunk of chunks) {
        allChunks.set(chunk, position);
        position += chunk.length;
      }
      returnSubject.next({
        contentLength,
        receivedLength,
        percentage,
        content: new Blob([allChunks]),
        done: true
      });
    });

    return returnSubject;
  }

  public static pulisciNumeroPerPrezzo(num) {
    return Utils.ReplaceAll(num, ',', '.');
  }
  // public static salvaFile(blob: Blob | string, nomeFile: string) {
  //   fileSaver.saveAs(blob, moment().format('DD/MM/YYYY') + '_' + nomeFile);
  // }
  public static salvaFile(blob: Blob | string, nomeFile: string, prepend_data?: boolean) {
    fileSaver.saveAs(
      blob,
      prepend_data === true || prepend_data === undefined ? moment().format('DD/MM/YYYY') + '_' + nomeFile : nomeFile
    );
  }
  public static salvaFileLink(blob: string, nomeFile: string) {
    fileSaver.saveAs(blob, moment().format('DD/MM/YYYY') + '_' + nomeFile);
  }
  public static salvaFileResponse(data: HttpResponse<Blob>) {
    const cdHeader = data.headers.get('Content-Disposition');
    const filename = cdHeader.match(/filename=(.+)/)[1].replace(/"/g, '');
    const blob = new Blob([data.body], { type: 'application/pdf' });
    fileSaver.saveAs(blob, filename);
  }
  public static generateDatasetRubrica(ds) {
    const keys = Object.keys(ds);
    const arr = [];

    function generateNumberString(size) {
      let phone = '';
      for (let i = 0; i < size; i++) {
        phone += String(Math.floor(Math.random() * 10));
      }
      return phone;
    }

    keys.forEach(item => {
      arr.push({
        sezione: ds[item].p,
        dipartimento: ds[item].r,
        cf: generateNumberString(11),
        piva: Math.random() < 0.5 ? generateNumberString(11) : '',
        indirizzo: 'TBD',
        email: `${ds[item].p.toLowerCase()}@andi.it`,
        tel: generateNumberString(10),
        fax: Math.random() < 0.5 ? generateNumberString(10) : ''
      });
    });

    return arr;
  }

  public static base64ToFile(dataUrl: string, nameOptions?: { filename?: string; ext?: string }): File {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    console.log(mime);
    const filename = nameOptions ? nameOptions.filename || uuid() : uuid();
    const ext = nameOptions ? nameOptions.ext || mime.split('/')[1] : mime.split('/')[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], `${filename}.${ext}`, { type: mime });
  }

  public static resizeImage(file: File, maxSize: number): Promise<string> {
    const reader = new FileReader();
    const image = new Image();
    const canvas = document.createElement('canvas');
    const dataURItoBlob = (dataURI: string) => {
      const bytes =
        dataURI.split(',')[0].indexOf('base64') >= 0 ? atob(dataURI.split(',')[1]) : unescape(dataURI.split(',')[1]);
      const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
      const max = bytes.length;
      const ia = new Uint8Array(max);
      for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
      return new Blob([ia], { type: mime });
    };
    const resize = () => {
      let width = image.width;
      let height = image.height;

      if (width > height) {
        if (width > maxSize) {
          height *= maxSize / width;
          width = maxSize;
        }
      } else {
        if (height > maxSize) {
          width *= maxSize / height;
          height = maxSize;
        }
      }

      canvas.width = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(image, 0, 0, width, height);
      let dataUrl = canvas.toDataURL('image/jpeg');
      return dataURItoBlob(dataUrl);
    };

    return new Promise((ok, no) => {
      if (!file.type.match(/image.*/)) {
        no(new Error('Not an image'));
        return;
      }

      reader.onload = (readerEvent: any) => {
        image.onload = () => ok(this.fileToDataUrl(resize()));
        image.src = readerEvent.target.result;
      };
      reader.readAsDataURL(file);
    });
  }
  public static fileToDataUrl(file: File | Blob, rawBase64: boolean = false): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let encoded = String(reader.result);
        if (rawBase64) {
          let raw = encoded.replace(/^data:(.*;base64,)?/, '');
          if (raw.length % 4 > 0) {
            raw += '='.repeat(4 - (raw.length % 4));
          }
          resolve(raw);
          return;
        }
        resolve(encoded);
      };
      reader.onerror = reject;
    });
  }
  public static async convertImageToWebP(image: string): Promise<File> {
    if (image) {
      const img = new Image();
      img.src = image;
      const webpImage = await new Promise<File>((resolve, reject) => {
        img.onload = () => {
          try {
            const canv = document.createElement('canvas');
            canv.width = img.naturalWidth;
            canv.height = img.naturalHeight;
            canv.getContext('2d').drawImage(img, 0, 0);

            canv.toBlob(blob => {
              try {
                const webP = new File([blob], `${uuid()}.webp`, { type: blob.type });
                console.log(webP);
                resolve(webP);
              } catch (error) {
                reject(error);
              }
            }, 'image/webp');
          } catch (error) {
            reject(error);
          }
        };
      });
      console.log('POST PROMISE: ', webpImage);
      return webpImage;
    }
    return null;
  }

  public static async convertBlobUrlToBase64(blobUrl: string): Promise<string> {
    const response = await fetch(blobUrl);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = () => {
        reject(new Error('Errore durante la conversione del Blob in Base64'));
      };
      reader.readAsDataURL(blob);
    });
  }
  // #################################################################
}
export function toFormData<T>(formValue: T, others?) {
  const formData = new FormData();

  for (const key of Object.keys(formValue)) {
    const value = formValue[key];
    formData.append(key, value);
  }
  if (others) {
    for (const key of Object.keys(others)) {
      const value = others[key];
      formData.append(key, value);
    }
  }
  return formData;
}
function convertBase(value, from_base, to_base) {
  var range = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ+/'.split('');
  var from_range = range.slice(0, from_base);
  var to_range = range.slice(0, to_base);

  var dec_value = value
    .split('')
    .reverse()
    .reduce(function (carry, digit, index) {
      if (from_range.indexOf(digit) === -1)
        throw new Error('Invalid digit `' + digit + '` for base ' + from_base + '.');
      return (carry += from_range.indexOf(digit) * Math.pow(from_base, index));
    }, 0);

  var new_value = '';
  while (dec_value > 0) {
    new_value = to_range[dec_value % to_base] + new_value;
    dec_value = (dec_value - (dec_value % to_base)) / to_base;
  }
  return new_value || '0';
}
export function getNumeroDecToBase(num: number, base: number) {
  return convertBase(num.toString(), 10, base);
}
export function getNumeroFatturaElettronicaXML(num: string, anno: number, serie: string = null, toBase: number) {
  let numFromSerie = 0;
  if (serie) {
    numFromSerie = serie
      .split('')
      .map(item => +item.charCodeAt(0))
      .reduce((a, b) => a + b);
  }
  const numFatturaAnno = (
    anno +
    +numFromSerie +
    +Utils.ReplaceAll(num.toString().replace(/[^0-9.]+/g, ''), ' ', '')
  ).toString();
  const numConverted = convertBase(numFatturaAnno, 10, toBase).trim().padStart(5, '0');

  return numConverted.substring(numConverted.length - 5, numConverted.length);
}
export function getNumeroFatturaElettronicaXMLFromID(idFattura, toBase: number) {
  const numFatturaAnno = idFattura.toString();
  const numConverted = convertBase(numFatturaAnno, 10, toBase).trim().padStart(5, '0');

  return numConverted.substring(numConverted.length - 5, numConverted.length);
}
